import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom';
import { verifyCustomerEmail } from '../../utils/APIClient';
import { triggerAlert } from '../../utils/commonFunctions';
import SpinnerLoader from '../../Components/SpinnerLoader';

const EmailVerification = () => {
    const [status, setStatus] = useState('verifying');
    const [userMail, setUserMail] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email');
        const token = params.get('token');
        const OTP = params.get('OTP');

        // Optional: you can log or use token/OTP if needed
        console.log({ email, token, OTP });

        const verifyEmail = async () => {
            setStatus('verifying');
            try {
                const res = await verifyCustomerEmail({
                    email: email,
                    // password: 'Suri@9502', // Confirm this—usually, email verification doesn't include password
                    otp: OTP, // Confirm this—usually, email verification doesn't include password
                })
                console.log("verifyEmail", res);
                setStatus('success');
            } catch (err) {
                console.error(err);
                triggerAlert('error', '', err?.response?.data?.error || 'Something went wrong');
                setStatus('failed');
            }
        };

        if (email) {
            setUserMail(email);
            verifyEmail();
        } else {
            setStatus('failed');
        }
    }, []);

    const resendOTP = async () => {
        if (userMail) {
            try {
                const res = await resendOTP({
                    email: userMail,
                })
                console.log("verifyEmail", res);
                triggerAlert('info', '', 'A new OTP has been sent to your email. Please check your inbox.');
            } catch (err) {
                console.error(err);
                triggerAlert('error', '', err?.response?.data?.error || 'Something went wrong');
                setStatus('failed');
            }
        } else {
            triggerAlert('info', '', 'Please check your email and try again to verify');
        }

    }

    return (
        <div className='d-flex flex-column align-items-center' style={{ maxHeight: '100vh' }}>

            {status === 'verifying' && (
                <>
                    <h1 className="mb-3">Verifying your email...</h1>
                    <p>Please wait while we confirm your email address. This should only take a moment.</p>
                    <SpinnerLoader />
                </>
            )}

            {status === 'success' && (
                <>
                    <h1 className="mb-3">Email Verified!</h1>
                    <blockquote className="blockquote">
                        <p>
                            Your email has been successfully verified. Welcome to VoiceBuddy!
                            You can now log in and start exploring all the features we offer.
                        </p>
                    </blockquote>
                    <p className="mt-3">
                        Go back to <Link to="/login">Login</Link>
                    </p>
                </>
            )}

            {status === 'failed' && (
                <>
                    <h1 className="mb-3 text-danger">Verification Failed</h1>
                    <blockquote className="blockquote">
                        <p>
                            Oops! Something went wrong while verifying your email. Please make sure the link is correct,
                            or contact our support team for help.
                        </p>
                    </blockquote>
                    <p className="mt-3">
                        Didn't receive the activation link or your OTP has expired? <a href="#/" className='text-primary text-decoration-underline' onClick={resendOTP}> Resend</a>
                    </p>
                </>
            )}


            {/* <p>{status}</p> */}
        </div>
    );
};

export default EmailVerification;
